<template>
  <div @click="onClose" class="wrapper" v-if="open">
    <div id="globalModal" :class="{wrapper_body: true}">
      <div :class="{'modal_body': true, 'small': incomeData?.drawer?.small }">
        <button @click="onClose(null, true)" class="btn btn-default btn-sm position-absolute close_btn" type="button">
          <i class="icon-fa icon-fa-close"></i>
        </button>
        <template v-if="incomeData.type === 'filesPreview'">
          <PreviewPage :files="incomeData.files"/>
        </template>
        <template v-if="incomeData.type === 'pairSMSToOrder'">
          <PairSMS :orderId="incomeData.orderId" :cardId="incomeData.cardId" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'prePaid'">
          <PrePaidManage :order="incomeData.order" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'editServicePhone'">
          <EditPhone :phone="incomeData.phone" :callBackAction="callBackAction" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'editCreditCardUser'">
          <EditUser :user="incomeData.user" :callBackAction="callBackAction" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'editOrderInvoice'">
          <EditOrderInvoice :id="incomeData.invoiceId" :callBackAction="callBackAction" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'editInvoice'">
          <EditInvoice :invoiceId="incomeData.invoiceId" :callBackAction="callBackAction" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'storeAdjustmentsByDrug'">
          <AdjustInvoices :drug="{id:incomeData.drugId}" :callBackAction="callBackAction" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'storeDrugMoves'">
          <DrugMoves :data="incomeData.drugData"
                     :storeId="incomeData.storeId"
                     :inStore="incomeData.inStore"
                     :callBackAction="callBackAction"
                     :closeDrawer="onClose"
          />
        </template>

        <template v-if="incomeData.type === 'drugEditSite'">
          <DrugSiteEdit
            :hideSelect="true"
            :loadDrug="{...incomeData}"
          />
        </template>
        <template v-if="incomeData.type === 'dialogs'">
          <OrdersChat
            :orderId="incomeData.orderId"
          />
        </template>
        <template v-if="incomeData.type === 'drugDetailCopy'">
          <DetailCopy :drugId="incomeData.drugId" :drugDetailId="incomeData.detailId" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'DrugStatisticMultiTask'">
          <MultiTaskFromStat :record="incomeData.record" :task="incomeData.task" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'ClientIncomeRequest'">
          <ClientRequest :data="incomeData.data" :closeDrawer="onClose"/>
        </template>
        <template v-if="incomeData.type === 'orderDetailsForRunner'">
          <RunnerOrderDetails :orderId="incomeData.orderId"/>
        </template>
        <template v-if="incomeData.type === 'priceChangeTasks'">
          <UpdateDrugStatusPrice
            :tasks="incomeData.records"
          />
        </template>
        <template v-if="incomeData.type === 'drugTasks003'">
          <template v-if="incomeData.task.type_id === 22">
            <ManufacturerDrugInfoTask
              :task="incomeData.task"
            />
          </template>
        </template>
        <template v-if="incomeData.type === 'ActivationDrugDelay'">
          <ActivationDrugDelay :drug="incomeData.drug"/>
        </template>
        <template v-if="incomeData.type === 'storeDrugTrends'">
          <StoreTrends :drug="incomeData.drug"/>
        </template>
        <template v-if="incomeData.type === 'ChatReplySnippets'">
          <ChatReplySnippets :onSelect="(m) => {
            callBackAction(m);
            this.onClose(null, true);
          }"/>
        </template>
        <template v-if="incomeData.type === 'taskView'">
          TASK VIEW
          <!--          <GlobalTaskView :task="incomeData.task ?? {}" :incomeData="(t) => incomeData.task = t" :taskId="incomeData.taskId"-->
          <!--                          :groups="{}"/>-->
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import OrdersChat from "@/components/chat/OrdersChat";
import PairSMS from "@/components/orders/PairSMS";
import PreviewPage from "@/components/files/PreviewPage";
import PrePaidManage from "@/components/orders/prePaid/PrePaidManage";
import EditPhone from "@/views/admin/settings/cards/components/EditPhone";
import EditUser from "@/views/admin/settings/cards/components/EditUser";
import EditOrderInvoice from "@/views/admin/invoices/EditOrderInvoice.vue";
import DrugSiteEdit from "@/views/drugs/DrugSiteEdit.vue";
import EditInvoice from "@/views/admin/invoices/edit.vue"
import AdjustInvoices from "@/views/stores/components/AdjustInvoices.vue";
import DrugMoves from "@/views/nomenclature/components/DrugMoves.vue";
import DetailCopy from "@/views/drugs/componetns/DetailCopy.vue";
import MultiTaskFromStat from "@/views/statistics/components/MultiTaskFromStat.vue";
import {customUpdateData} from "@/eventsBus";
import ClientRequest from "@/components/clients/ClientRequest.vue";
import ManufacturerDrugInfoTask from "@/views/tasks/types/ManufacturerDrugInfoTask.vue";
import UpdateDrugStatusPrice from "@/views/tasks/components/UpdateDrugStatusPrice.vue";
import RunnerOrderDetails from "@/components/orders/runners/OrderDetails.vue";
import GlobalTaskView from "@/views/tasks/components/GlobalTaskView.vue";
import StoreTrends from "@/components/drugs/StoreTrends.vue";
import ChatReplySnippets from "@/views/customersRequests/components/ChatReplySnippets.vue";
import ActivationDrugDelay from "@/components/drugs/ActivationDrugDelay.vue";
import store from "@/store";

export default {
  components: {
    ChatReplySnippets,
    StoreTrends,
    GlobalTaskView,
    RunnerOrderDetails,
    UpdateDrugStatusPrice,
    ManufacturerDrugInfoTask,
    ClientRequest,
    MultiTaskFromStat,
    EditPhone,
    PairSMS,
    OrdersChat,
    PreviewPage,
    PrePaidManage,
    EditUser,
    EditOrderInvoice,
    DrugSiteEdit,
    EditInvoice,
    AdjustInvoices,
    DrugMoves,
    DetailCopy,
    ActivationDrugDelay,
  },
  data() {
    return {
      open: false,
      incomeData: null,
      callBack: null,
      callBackAction: null,
    }
  },
  computed: {
    $GlobalDrawerData() {
      return this.$store.getters["platform/globalDrawerData"];
    },
  },
  watch: {
    '$GlobalDrawerData': {
      handler: function (val, oldVal) {
        // console.log(val);
        if (!val) {
          this.onClose(null, true, false, false);
          return;
        }
        this.callBackAction = null;
        this.openModal();
      },
      deep: true
    },
  },
  mounted() {
  },
  beforeDestroy() {
    this.$store.dispatch("platform/setIsGlobalDrawerOpen", false);
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
  },
  methods: {
    openModal() {
      this.incomeData = null;
      this.open = false;
      if (!this.$GlobalDrawerData) return;
      // console.log(this.$GlobalDrawerData);
      const body = document.getElementsByTagName('body')[0]
      body.style.overflow = 'hidden'
      this.incomeData = {...this.$GlobalDrawerData.data}
      this.callBackAction = this.$GlobalDrawerData.callBackAction;
      this.$store.dispatch("platform/setIsGlobalDrawerOpen", true);
      this.open = true;
    },
    onClose(e, global = false, useCallBack = false, clearStore = true) {
      if (global || (e && e.target && e.target.id === 'globalModal')) {
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";
        // console.log(this.$GlobalDrawerData?.callBackAction);
        switch (this.$GlobalDrawerData?.callBackAction) {
          case 'resetOrder':
            this.$store.dispatch('orders/setEditNewOrder', {});
            break;
          case 'closeOrderModal':
            this.$store.dispatch('orders/setOrderToEdit', {});
            break;
          case 'refreshMSStatList':
            if (!useCallBack) break;
            customUpdateData.$emit(
              this.$GlobalDrawerData.callBackAction,
              {update: true}
            );
            break;
          default:
            break;
        }
        this.incomeData = null;
        this.open = false;
        this.$store.dispatch("platform/setIsGlobalDrawerOpen", false);
        if (clearStore) this.$store.dispatch('platform/setGlobalDrawerData', null);
      }
    },
  }
}

</script>

<style scoped>
.modal_body .main-content {
  padding: 0;
}

.loading_div {
  position: absolute;
  top: 50%;
  left: 50%;
}

.modal_body.small {
  width: 50%;
}

.modal_body {
  background-color: #efefef;
  //background-color: white; height: 100vh; width: 75%; position: absolute; right: 0; padding: 15px; overflow: auto;
}

.wrapper_body.open {
  /*left: calc(100% - 300px);*/
  /*left: 25%;*/
  transition: all 0.3s ease 0s;
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  width: 100%;
  /*left: 100%;*/
  min-height: 100%;
  z-index: 9;
  background-color: transparent;
}

.wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 201;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}

.close_btn {
  right: 5px;
  top: 5px;
  z-index: 11;
}

.modal_body .main-content {
  padding: 0;
  min-height: auto;
}
</style>
